import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import LoadingSpinner from "./dev/LoadingSpinner";

const { REACT_APP_URI = "/" } = process.env;
const styles = {
  root: {
    color: "#979797",
    "&$checked": {
      color: "#ee8282",
    },
  },
  checked: {},
};
class CancelSubscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question1value: "",
      question2value: {
        [props.messages.user_cancel_answer_find]: false,
        [props.messages.user_cancel_answer_analyze]: false,
        [props.messages.user_cancel_answer_ranking]: false,
        [props.messages.user_cancel_answer_project]: false,
        [props.messages.user_cancel_answer_channel]: false,
        [props.messages.contact_other]: false,
      },
      question2OtherValue: "",
      question3value: "",
      question3OtherValue: "",
      question4value: "",
      question5value: "",
      response: "",
      isLoading: false,
      isAllButtonDisabled: false,
      canCancelSubscription: true,
    };
  }
  componentDidMount = () => {
    fetch(`${REACT_APP_URI}/accounts/userPayHistory/`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((userPayHistory) => {
        const { nextPayDate } = userPayHistory;
        this.setState({ nextPayDate });
      });
    fetch(`${REACT_APP_URI}/accounts/canCancelSubscription/`, {
      credentials: "include",
    }).then((res) => {
      this.setState({ canCancelSubscription: res.ok });
    });
  };
  radioChange = (name, value) => {
    // 選擇其他欄以外的選項，清空其他欄的input
    if (value !== this.props.messages.contact_other)
      this.setState({ [`${name}OtherValue`]: "" });
    this.setState({ [`${name}value`]: value });
  };
  checkboxChange = (name, value) => {
    // 在選項為其他欄的情況下從點選變為取消，則清空其他欄的input
    if (
      value === this.props.messages.contact_other &&
      this.state[`${name}value`][value] === true
    )
      this.setState({ question2OtherValue: "" });
    this.setState({
      [`${name}value`]: {
        ...this.state[`${name}value`],
        [value]: !this.state[`${name}value`][value],
      },
    });
  };
  textareaInput = (name) => (e) =>
    this.setState({ [`${name}value`]: e.target.value });
  cancelSubmit = () => {
    const {
      user: { token, email },
      messages,
    } = this.props;
    const {
      question1value,
      question2value,
      question3value,
      question4value,
      question5value,
      question2OtherValue,
      question3OtherValue,
      nextPayDate,
    } = this.state;
    const question2FinalVaue = Object.entries(question2value)
      .filter((i) => i[1] === true)
      .map((i) => i[0]);
    const question2FinalOtherValue = question2value[
      this.props.messages.contact_other
    ]
      ? question2OtherValue
      : "";
    this.setState({ isAllButtonDisabled: true, isLoading: true });
    fetch(`${REACT_APP_URI}/accounts/cancelSubscription/`, {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": token,
      },
    }).then((res) => {
      if (res.ok) {
        fetch(
          `https://script.google.com/macros/s/AKfycbwfRTyoxL3PLMkx0wtQ0lc2894QYLDLfjqufsCDKlu_b20AhTHX/exec`,
          {
            method: "post",
            credentials: "include",
            mode: "no-cors",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: email,
              answers: {
                q1: question1value,
                q2: question2FinalVaue,
                q2Other: question2FinalOtherValue,
                q3: question3value,
                q3Other: question3OtherValue,
                q4: question4value,
                q5: question5value,
              },
            }),
          }
        ).then(() => {
          this.setState(
            {
              response: `${messages.user_pay_stop_pay} ${nextPayDate}`,
              isLoading: false,
            },
            () =>
              setTimeout(() => {
                this.props.history.push("/UserInfo");
              }, 3000)
          );
        });
      } else
        this.setState({
          response: messages.payment_unknown_error,
          isLoading: false,
        });
    });
  };
  cancelReset = () => {
    this.setState({
      question1value: "",
      question2value: {
        [this.props.messages.user_cancel_answer_find]: false,
        [this.props.messages.user_cancel_answer_analyze]: false,
        [this.props.messages.user_cancel_answer_ranking]: false,
        [this.props.messages.user_cancel_answer_project]: false,
        [this.props.messages.user_cancel_answer_channel]: false,
        [this.props.messages.contact_other]: false,
      },
      question2OtherValue: "",
      question3value: "",
      question3OtherValue: "",
      question4value: "",
      question5value: "",
    });
  };
  isSubmitButtonActive = () => {
    const {
      question1value,
      question2value,
      question3value,
      question4value,
      question5value,
      question2OtherValue,
      question3OtherValue,
    } = this.state;
    const radioCheck = ![
      question1value,
      question3value,
      question4value,
    ].includes(""); //若為true則三個問題都不為空值
    const checkboxCheck = Object.values(question2value).includes(true); //若為ture則不為空
    const otherCheck = () => {
      const question2OtherValueCheck = question2value[
        this.props.messages.contact_other
      ]
        ? question2OtherValue !== ""
          ? true
          : false
        : true;
      const question3OtherValueCheck =
        question3value === this.props.messages.contact_other
          ? question3OtherValue !== ""
            ? true
            : false
          : true;
      return question2OtherValueCheck && question3OtherValueCheck;
    };
    const textAreaCheck = question5value !== "";
    const allCheck =
      radioCheck && checkboxCheck && textAreaCheck && otherCheck();
    return allCheck;
  };
  //以下為render fuctions
  renderRadio = ({ name, title, options }) => {
    const { radioChange } = this;
    const { messages, classes } = this.props;
    const { isAllButtonDisabled } = this.state;
    return (
      <Wrap padding column>
        <SubTitle margin="0 0 5px 0" bold>
          {title}
        </SubTitle>
        {options.map(({ value, text }) => {
          return (
            <React.Fragment>
              <Wrap>
                <Radio
                  onChange={() => radioChange(name, value)}
                  classes={{
                    root: classes.root,
                    checked: classes.checked,
                  }}
                  value={value}
                  checked={this.state[`${name}value`] === value}
                  id={name + value}
                  disabled={isAllButtonDisabled}
                  style={{ width: 36, height: 36 }}
                  icon={<RadioButtonUncheckedIcon style={{ fontSize: 20 }} />}
                  checkedIcon={
                    <RadioButtonCheckedIcon style={{ fontSize: 20 }} />
                  }
                />
                <StyledLabel htmlFor={name + value}>{text}</StyledLabel>
              </Wrap>
              {/*只有在情況是其他時會出現*/}
              {text === messages.contact_other && (
                <Input
                  value={this.state[`${name}OtherValue`]}
                  onInput={(e) =>
                    this.setState({ [`${name}OtherValue`]: e.target.value })
                  }
                  onFocus={() => this.setState({ [`${name}value`]: value })}
                />
              )}
            </React.Fragment>
          );
        })}
      </Wrap>
    );
  };
  renderCheckbox = ({ name, title, options }) => {
    const { checkboxChange } = this;
    const { messages, classes } = this.props;
    const { isAllButtonDisabled } = this.state;
    return (
      <Wrap padding column>
        <SubTitle margin="0 0 5px 0" bold>
          {title}
        </SubTitle>
        {options.map(({ value, text }) => {
          return (
            <React.Fragment>
              <Wrap>
                <Checkbox
                  onChange={() => checkboxChange(name, value)}
                  classes={{
                    root: classes.root,
                    checked: classes.checked,
                  }}
                  value={value}
                  checked={this.state[`${name}value`][value]}
                  id={name + value}
                  disabled={isAllButtonDisabled}
                  style={{ width: 36, height: 36 }}
                  icon={<CheckBoxOutlineBlankIcon style={{ fontSize: 20 }} />}
                  checkedIcon={<CheckBoxIcon style={{ fontSize: 20 }} />}
                />
                <StyledLabel htmlFor={name + value}>{text}</StyledLabel>
              </Wrap>
              {/*只有在情況是其他時會出現*/}
              {text === messages.contact_other && (
                <Input
                  value={this.state[`${name}OtherValue`]}
                  onInput={(e) =>
                    this.setState({ [`${name}OtherValue`]: e.target.value })
                  }
                  onFocus={() =>
                    this.setState({
                      [`${name}value`]: {
                        ...this.state[`${name}value`],
                        [value]: true,
                      },
                    })
                  }
                />
              )}
            </React.Fragment>
          );
        })}
      </Wrap>
    );
  };
  renderTextarea = ({ name, title }) => {
    const { textareaInput } = this;
    return (
      <Wrap padding paddingBottom column>
        <SubTitle margin="0 0 5px 0" bold>
          {title}
        </SubTitle>
        <Textarea
          onInput={textareaInput(name)}
          value={this.state[`${name}value`]}
          type="text"
          placeholder={""}
        />
      </Wrap>
    );
  };
  render() {
    const {
      renderRadio,
      renderCheckbox,
      renderTextarea,
      isSubmitButtonActive,
      cancelSubmit,
    } = this;
    const {
      messages,
      user: { plan },
    } = this.props;
    const {
      canCancelSubscription,
      nextPayDate,
      response,
      isLoading,
      isAllButtonDisabled,
    } = this.state;
    const question1 = {
      name: "question1",
      title: `1. ${messages.user_cancel_question_satisfy}`,
      options: [
        { text: messages.user_cancel_answer_very_satisfied, value: "非常滿意" },
        { text: messages.user_cancel_answer_somewhat_satisfied, value: "滿意" },
        { text: messages.user_cancel_answer_neutral, value: "普通" },
        { text: messages.user_cancel_answer_unsatisfied, value: "不滿意" },
        {
          text: messages.user_cancel_answer_very_unsatisfied,
          value: "非常不滿意",
        },
      ],
    };
    const question2 = {
      name: "question2",
      title: `2. ${messages.user_cancel_question_purpose}`,
      options: [
        {
          text: messages.user_cancel_answer_find,
          apiValue: 123,
          value: "尋找網紅、YouTuber，執行網紅行銷",
        },
        {
          text: messages.user_cancel_answer_analyze,
          value: "數據分析特定網紅、YouTube 頻道",
        },
        {
          text: messages.user_cancel_answer_ranking,
          value: "查看頻道排行、追蹤趨勢",
        },
        {
          text: messages.user_cancel_answer_project,
          value: "優化網紅行銷專案管理",
        },
        { text: messages.user_cancel_answer_channel, value: "優化頻道經營" },
        { text: messages.contact_other, value: "其他" },
      ],
    };
    const question3 = {
      name: "question3",
      title: `3. ${messages.user_cancel_question_reason}`,
      options: [
        {
          text: messages.user_cancel_answer_back,
          value: "暫時無需求，未來我若有需求會再訂閱",
        },
        {
          text: messages.user_cancel_answer_didnt_meet_need,
          value: "服務與我的需求不符",
        },
        {
          text: messages.user_cancel_answer_quality,
          value: "我對此服務的品質不滿意",
        },
        {
          text: messages.user_cancel_answer_alternative,
          value: "我找到了更好的替代品",
        },
        {
          text: messages.user_cancel_answer_customer_service,
          value: "客戶服務不佳",
        },
        { text: messages.contact_other, value: "其他" },
      ],
    };
    const question4 = {
      name: "question4",
      title: `4. ${messages.user_cancel_question_resubsribe}`,
      options: [
        { text: messages.user_cancel_answer_definitely, value: "一定會" },
        { text: messages.user_cancel_answer_probably, value: "可能會" },
        { text: messages.user_cancel_answer_notsure, value: "不確定" },
        { text: messages.user_cancel_answer_probablynot, value: "可能不會" },
        { text: messages.user_cancel_answer_definitelynot, value: "一定不會" },
      ],
    };
    const question5 = {
      name: "question5",
      title: `5. ${messages.user_cancel_question_feedback}`,
    };
    if (!canCancelSubscription) this.props.history.push("/");
    return (
      <Container>
        <Content>
          <Wrap padding paddingBottom column borderBottom>
            <Title>{messages.user_chancel_confirm}</Title>
            <SubTitle>{messages.user_cancel_intro_1}</SubTitle>
            <SubTitle>{messages.user_cancel_intro_2}</SubTitle>
          </Wrap>
          {renderRadio(question1)}
          {renderCheckbox(question2)}
          {renderRadio(question3)}
          {renderRadio(question4)}
          {renderTextarea(question5)}
          <Wrap padding paddingBottom column>
            {plan === "Agency" && (
              <SubTitle margin="0 0 10px 0" highlight>
                {messages.user_cancel_stop_agency}
              </SubTitle>
            )}
            <SubTitle margin="0 0 10px 0" highlight>
              {messages.user_chancel_date} {nextPayDate}{" "}
              {messages.user_chancel_stop_pay}
            </SubTitle>
          </Wrap>
          {isLoading && (
            <Wrap>
              <LoadingSpinner />
            </Wrap>
          )}
          {!isLoading && !isAllButtonDisabled && (
            <SubmitButtonWrap>
              <SubmitButton
                isActive={isSubmitButtonActive()}
                condition="comfirm"
                onClick={() => (isSubmitButtonActive() ? cancelSubmit() : "")}
              >
                {messages.user_cancel_stop}
              </SubmitButton>
              <SubmitButton
                isActive
                condition="cancel"
                onClick={() => this.props.history.push("/UserInfo")}
              >
                {messages.contact_back}
              </SubmitButton>
            </SubmitButtonWrap>
          )}
          {response !== "" && (
            <Wrap center paddingBottom color="#de0606">
              {response}
            </Wrap>
          )}
          {!isSubmitButtonActive() && (
            <Wrap center paddingBottom color="#de0606">
              {messages.user_cancel_not_finish}
            </Wrap>
          )}
        </Content>
      </Container>
    );
  }
}
CancelSubscription.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
  return {
    user: state.User,
    messages: state.Messages,
  };
};
export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(CancelSubscription))
);
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 900px;
  padding: 50px 0 120px 0;
  border-left: 1px solid #e6e6e6;
  font-size: 16px;
  font-weight: 300;
  color: #787878;
  @media (max-width: 900px) {
    min-width: 320px;
  }
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 900px;
  margin-top: 60px;
  background-color: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
  @media (max-width: 900px) {
    width: calc(100% - 40px);
    margin: 0 20px;
  }
  @media (max-width: 900px) {
    padding: 24px;
  }
`;
const Wrap = styled.div`
  display: flex;
  ${({ column }) =>
    column ? "flex-direction: column;" : "align-items: center;"};
  padding: ${({ padding }) => (padding ? "24px 48px 0px 48px" : "")};
  border-bottom: ${({ borderBottom }) =>
    borderBottom ? "1px solid #e6e6e6" : ""};
  padding-bottom: ${({ paddingBottom }) => (paddingBottom ? "24px" : "")};
  color: ${({ color }) => color};
  ${({ center }) => (center ? "justify-content: center" : "")};
  @media (max-width: 900px) {
    padding: ${({ padding }) => (padding ? "24px 0px 0px 0px" : "")};
  }
`;
const Title = styled.div`
  margin-bottom: 18px;
  font-size: 36px;
  font-weight: 500;
  color: #787878;
`;
const SubTitle = styled.div`
  margin: ${({ margin }) => margin};
  font-size: 16px;
  font-weight: ${({ bold }) => (bold ? 500 : 300)};
  color: ${({ highlight }) => (highlight ? "#de0606" : "787878")};
`;
const StyledLabel = styled.label`
  margin-right: 10px;
  font-size: 14px;
  font-weight: 300;
  color: #787878;
  cursor: pointer;
`;
const Input = styled.input`
  width: 100%;
  padding-left: 5px;
  border: solid 1px #dedede;
  font-size: 14px;
  font-weight: 300;
  color: #999999;
  margin-left: 8px;
  &:focus {
    border: solid 1px #999999;
    outline: none;
  }
`;
const Textarea = styled.textarea`
  width: 100%;
  height: 10rem;
  border: solid 1px #dedede;
  &:focus {
    border: solid 1px #999999;
    outline: none;
  }
  box-sizing: border-box;
`;
const SubmitButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;
const SubmitButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  padding: 0 5px;
  margin: 0 8px;
  color: ${({ condition }) =>
    (condition === "comfirm" && "#fff") ||
    (condition === "cancel" && "#787878")};
  font-size: 16px;
  background-color: ${({ condition }) =>
    (condition === "comfirm" && "#de0606") ||
    (condition === "cancel" && "transparent")};
  opacity: 0.8;
  box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
  cursor: pointer;
  ${({ isActive }) =>
    isActive
      ? ""
      : "cursor: not-allowed; background-color: #787878; color: #fff;"};
  &:hover {
    opacity: 1;
  }
`;



// WEBPACK FOOTER //
// ./src/CancelSubscription.js